import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.providers';
import { redirectLegacyUrls } from './app/utils/legacy-url-redirects';

if (environment.production) {
  enableProdMode();
}

if (!redirectLegacyUrls()) {
  bootstrapApplication(AppComponent, appConfig);
}
